module.exports = angular.module('cartographer.common.string', [])

$ = require 'jquery'
_ = require 'underscore'

module.exports.factory 'crtString', $DI (crtLog) ->
  # Pad a numeric expression with leading zeroes
  #
  # or(string, int) int -> string
  addLeadingZeroes = (input, len) ->
    str = "" + input
    while(str.length < len)
      str = "0" + str
    return str

  # Remove leading zeroes from a string
  #
  # string -> string
  stripLeadingZeroes = (str) ->
    while(str.length > 1 && str[0] == "0")
      str = str.substring(1)
    return str

  # string -> boolean
  isEmail = (str) ->
    /^[^@]+@[^@]+$/.test(str)

  # Weak check to see if `str` contains a string with
  # at least one intermediate space ("firstname lastname").
  #
  # string -> boolean
  isFullName = (str) ->
    /^([^ ]+)([ ]+[^ ]+)+$/.test(str)

  # string => or(string null)
  trimToNull = (str) ->
    str = $.trim(str)
    if str == "" then null else str

  # string -> string
  titleCase = (str) ->
    str.replace(/\w\S*/g, (txt) -> txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())

  stringAttr = (str, orElse = null) ->
    str ? orElse

  # string [any] -> or(number, any)
  intAttr = (str, orElse) ->
    # We do this (rather than use a default value on orElse)
    # so we can pass `null` as the second argument without it getting set to 0:
    if _.isUndefined(orElse) then orElse = 0
    num = parseInt(str, 10)
    if isNaN(num) then orElse else num

  booleanAttr = (str, orElse = false) ->
    if _.isString(str)
      _.contains(['y', 'yes', 't', 'true'], str.toLowerCase())
    else
      orElse

  arrayAttr = (str, delim = ',', orElse = []) ->
    if str? then str.split(delim).map($.trim) else orElse

  formatArrayAttr = (arr, delim = ',') ->
    arr.join(delim)

  # string -> string
  escapeHtml = (str) ->
    text = document.createTextNode("#{str}")
    elem = document.createElement("div")
    elem.appendChild(text)
    elem.innerHTML

  # string arrayOf(string) -> string
  nonConflictingName = (name, existing) ->
    if _.contains(existing, name)
      match = name.match(/^(.+?)([0-9]+)$/)
      if match
        stem  = match[1]
        index = parseInt(match[2])
      else
        stem  = name
        index = 1

      while _.contains(existing, "#{stem}#{index}")
        index = index + 1

      "#{stem}#{index}"
    else
      name

  randomSignupCode = ->
    chars = for index in [1..4]
      String.fromCharCode('A'.charCodeAt(0) + Math.random() * 26)
    chars.join('')

  # turn an array ["a", "b", "c"] into a string "a, b, and c"
  joinList = (items, stdSep = ", ", lastSep = ", and ") ->
    switch (items?.length ? 0)
      when 0 then ""
      when 1 then items[0]
      else
        ans = "#{items[0]}"
        for i in [1...items.length - 1]
          ans = "#{ans}#{stdSep}#{items[i]}"
        ans = "#{ans}#{lastSep}#{items[items.length - 1]}"
        ans

  escapeHtml = (str) ->
    span = document.createElement('span')
    span.innerText = str
    return span.innerHTML

  return {
    addLeadingZeroes
    stripLeadingZeroes
    isEmail
    isFullName
    trimToNull
    titleCase
    stringAttr
    intAttr
    booleanAttr
    arrayAttr
    formatArrayAttr
    escapeHtml
    nonConflictingName
    randomSignupCode
    joinList
  }

module.exports.filter 'sentencecase', $DI ->
  (value) ->
    if _.isString(value) && value.length > 0
      value.substring(0, 1).toUpperCase() + value.substring(1)
    else
      value

module.exports.filter 'crtJson', $DI ->
  (value) ->
    JSON.stringify(value, null, 2)

module.exports.filter 'crtNumber', $DI ->
  (value, dp = 2) ->
    if typeof value == 'number' then value.toFixed(dp) else value

module.exports.filter 'crtOrElse', $DI ->
  (value, orElse) ->
    if value? then value else orElse
